<template>
  <div class="create-quotation">
    <Header />
    <div uk-height-viewport>
      <div class="uk-flex uk-flex-center">
        <div>
          <br />

          <progress
            id="progressbar"
            class="uk-progress"
            value="0"
            max="100"
          ></progress>

          <div
            class="
              uk-card
              uk-card-default
              uk-padding
              uk-flex
              uk-flex-center
              uk-border-rounded
            "
          >
            <form
              v-on:submit.prevent="createQuotation"
              v-show="newQuotationMod"
            >
              <fieldset class="uk-fieldset">
                <legend class="uk-legend uk-text-bolder uk-text-left">
                  Vos informations personnelles
                </legend>

                <br />

                <div uk-grid>
                  <div class="uk-width-auto@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Civilité</label
                    >
                    <select
                      class="uk-select uk-border-rounded"
                      v-model="form.gender.value"
                    >
                      <option value="male">Monsieur</option>
                      <option value="female">Madame</option>
                    </select>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Nom</label
                    >
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.lastName.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="text"
                      placeholder="Votre nom"
                      @blur="checkLastName()"
                      v-model="form.lastName.value"
                      autofocus
                      required
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.lastName.errorMessage
                    }}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Prénom</label
                    >
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.firstName.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="text"
                      v-model="form.firstName.value"
                      @blur="checkFirstName()"
                      placeholder="Votre prénom"
                      required
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.firstName.errorMessage
                    }}</label>
                  </div>
                </div>

                <div uk-grid>
                  <div class="uk-width-1-2@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Téléphone</label
                    >
                    <!-- <div class="uk-inline"> -->
                    <!-- <span class="uk-form-icon" uk-icon="icon: receiver"></span> -->
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.phoneNumber.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="tel"
                      placeholder="0X XX XX XX XX"
                      @blur="isPhoneNumber()"
                      v-model="form.phoneNumber.value"
                      pattern="0.*[0-9]{9}$"
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.phoneNumber.errorMessage
                    }}</label>
                    <!-- </div> -->
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Adresse e-mail</label
                    >
                    <!-- <div class="uk-inline"> -->
                    <!-- <span class="uk-form-icon" uk-icon="icon: mail"></span> -->
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.email.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="email"
                      placeholder="votre.adresse@email.com"
                      @blur="isEmail()"
                      v-model="form.email.value"
                      pattern="[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$"
                      required
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.email.errorMessage
                    }}</label>
                  </div>
                  <!-- </div> -->
                </div>

                <br />
                <br />
                <hr />
                <br />

                <legend class="uk-legend uk-text-bolder uk-text-left">
                  Localisation du bien
                </legend>

                <br />

                <div uk-grid>
                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Adresse</label
                    >
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.address.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="text"
                      v-model="form.address.value"
                      @blur="checkAddress()"
                      placeholder="Rue, Avenue, Chemin..."
                      required
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.address.errorMessage
                    }}</label>
                  </div>
                </div>

                <div uk-grid>
                  <div class="uk-width-auto@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Code postal</label
                    >
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.zipCode.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="text"
                      v-model="form.zipCode.value"
                      placeholder="XXXXX"
                      @blur="isZipCode()"
                      pattern="[0-9]{5}$"
                      required
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.zipCode.errorMessage
                    }}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Ville</label
                    >
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.city.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="text"
                      v-model="form.city.value"
                      @blur="checkCity()"
                      placeholder=""
                      required
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.city.errorMessage
                    }}</label>
                  </div>

                  <div class="uk-width-expand@m">
                    <label
                      class="uk-form-label uk-align-left uk-text-bold"
                      for="form-stacked-text"
                      >Pays</label
                    >
                    <input
                      class="uk-input uk-border-rounded"
                      v-bind:class="[
                        form.country.hasError ? 'uk-form-danger' : '',
                      ]"
                      type="text"
                      v-model="form.country.value"
                      @blur="checkCountry()"
                      placeholder="France"
                      required
                    />
                    <label class="uk-form-label uk-align-left uk-text-danger">{{
                      form.country.errorMessage
                    }}</label>
                  </div>
                </div>

                <br />
                <br />
                <hr />
                <br />

                <legend class="uk-legend uk-text-bolder uk-text-left">
                  Quelle(s) prestation(s) souhaitez-vous faire estimer ?
                </legend>

                <br />

                <div
                  uk-grid
                  v-for="(delivery, index) in selectedDeliveries"
                  :key="index"
                >
                  <div class="uk-width-expand@m">
                    <input
                      class="uk-input uk-border-rounded"
                      type="text"
                      :value="delivery.title"
                      readonly
                    />
                  </div>

                  <div class="uk-width-1-3@m">
                    <input
                      class="uk-input uk-border-rounded"
                      type="number"
                      :placeholder="getUnitLabelForDelivery(delivery)"
                      v-model="delivery.surface"
                      :min="getMinimumSurfaceForDelivery(delivery)"
                      required
                    />
                  </div>

                  <div class="uk-width-auto@m">
                    <span
                      class="uk-icon-button"
                      style="cursor: pointer"
                      uk-icon="icon: trash;"
                      v-on:click="deleteDeliveryAt(index)"
                    ></span>
                  </div>
                </div>

                <div uk-grid>
                  <div class="uk-width-auto@m">
                    <div uk-form-custom="target: > * > span:first-child">
                      <select
                        v-model="selectedDelivery"
                        @change="addDelivery(selectedDelivery)"
                      >
                        <option>{{ selectDeliveryTitle }}</option>
                        <option
                          v-bind:value="delivery"
                          v-for="(delivery, index) in dataDeliveries"
                          :key="index"
                          v-show="deliveryAlreadySelected(delivery)"
                        >
                          {{ delivery.title }}
                        </option>
                      </select>
                      <button
                        class="uk-button uk-button-default"
                        type="button"
                        tabindex="-1"
                      >
                        <span></span>
                        <span uk-icon="icon: chevron-down"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <br />

                <div
                  class="
                    uk-margin
                    uk-grid-small
                    uk-child-width-auto
                    uk-flex
                    uk-flex-center
                  "
                  v-show="selectedDeliveries.length > 0"
                >
                  <label>
                    <input
                      class="uk-checkbox uk-center"
                      type="checkbox"
                      id="checkbox"
                      v-model="isChecked"
                    />
                    J'accepte d'être contacté(e) par la société Check my House
                  </label>
                </div>

                <br />

                <div
                  uk-grid
                  v-show="isChecked"
                  class="
                    uk-margin
                    uk-grid-small
                    uk-child-width-auto
                    uk-flex
                    uk-flex-center
                    uk-margin-remove-top
                  "
                >
                  <div class="uk-width-auto@m uk-flex-center uk-border-rounded">
                    <div uk-form-custom="target: > * > span:first-child">
                      <select
                        v-model="selectedCommunicationType"
                        class="uk-border-rounded"
                      >
                        <option>{{ selectCommunicationTitle }}</option>
                        <option
                          v-bind:value="communication"
                          v-for="(
                            communication, index
                          ) in dataCommunicationTypes"
                          :key="index"
                        >
                          {{ communication.title }}
                        </option>
                      </select>
                      <button
                        class="uk-button uk-button-default"
                        type="button"
                        tabindex="-1"
                      >
                        <span></span>
                        <span uk-icon="icon: chevron-down"></span>
                      </button>
                    </div>
                  </div>
                </div>

                <div v-show="!isConnected">
                  <div
                    v-show="
                      isChecked &&
                      selectedDeliveries.length > 0 &&
                      !isLoading &&
                      selectedCommunicationType != selectCommunicationTitle
                    "
                    class="
                      uk-margin
                      uk-grid-small
                      uk-child-width-auto
                      uk-flex
                      uk-flex-center
                    "
                  >
                    <button
                      class="
                        uk-button
                        uk-button-primary
                        uk-animation-scale-up
                        uk-border-rounded
                      "
                    >
                      RECEVOIR MON DEVIS PERSONNALISÉ
                    </button>
                  </div>
                  <div
                    v-show="
                      isChecked &&
                      selectedDeliveries.length > 0 &&
                      !isLoading &&
                      selectedCommunicationType != selectCommunicationTitle
                    "
                    class="
                      uk-margin
                      uk-grid-small
                      uk-child-width-auto
                      uk-flex
                      uk-flex-center
                    "
                  >
                    <p class="uk-text-center uk-text-small">
                      Un email va vous être envoyé à l'adresse indiqué.
                    </p>
                  </div>
                </div>

                <div v-show="isConnected">
                  <div
                    v-show="
                      isChecked &&
                      selectedDeliveries.length > 0 &&
                      !isLoading &&
                      selectedCommunicationType != selectCommunicationTitle
                    "
                    class="
                      uk-margin
                      uk-grid-small
                      uk-child-width-auto
                      uk-flex
                      uk-flex-center
                    "
                  >
                    <button
                      type="button"
                      class="
                        uk-button
                        uk-button-primary
                        uk-animation-scale-up
                        uk-border-rounded
                        uk-text-bold
                      "
                      v-on:click="createQuotation()"
                    >
                      GENERER MON DEVIS
                    </button>
                  </div>
                  <div
                    v-show="
                      isChecked &&
                      selectedDeliveries.length > 0 &&
                      !isLoading &&
                      selectedCommunicationType != selectCommunicationTitle
                    "
                    class="
                      uk-margin
                      uk-grid-small
                      uk-child-width-auto
                      uk-flex
                      uk-flex-center
                    "
                  ></div>
                </div>

                <br />
                <div
                  class="
                    uk-margin
                    uk-grid-small
                    uk-child-width-auto
                    uk-flex
                    uk-flex-center
                  "
                  uk-spinner
                  v-show="isLoading"
                ></div>

                <button
                  v-show="userCanPay"
                  class="
                    uk-button
                    uk-button-primary
                    uk-animation-fade
                    uk-border-rounded
                    uk-text-bold
                  "
                >
                  RÉGLER {{ quotation.amount.toFixed(2) }}€
                </button>

                <br />
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UIkit from "uikit";
import DeliveryType from "../enums/delivery-type";
import CommunicationType from "../enums/communication-type";
import Header from "../components/Header";
import router from "../router";
import firebase from "firebase";

export default {
  name: "create-quotation",
  components: {
    Header,
  },

  mounted() {
    const self = this;
    self.isConnected = localStorage.currentUser != null;

    if (self.isConnected && localStorage.getItem("currentUser")) {
      try {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        this.form.firstName.value = this.currentUser.firstName;
        this.form.lastName.value = this.currentUser.lastName;
        this.form.gender.value = this.currentUser.gender;
        this.form.phoneNumber.value = this.currentUser.phoneNumber;
        this.form.email.value = this.currentUser.email;
        this.form.address.value = this.currentUser.address.address;
        this.form.zipCode.value = this.currentUser.address.zipCode;
        this.form.city.value = this.currentUser.address.city;
        this.form.country.value = this.currentUser.address.country;
      } catch (e) {
        localStorage.removeItem("currentUser");
      }
    }
  },

  data() {
    return {
      currentUser: {},
      quotation: { amount: 0 },
      newQuotationMod: true,
      form: {
        firstName: { value: "", hasError: false },
        lastName: { value: "", hasError: false },
        gender: { value: "male", hasError: false },
        phoneNumber: { value: "", hasError: false },
        email: { value: "", hasError: false },
        address: { value: "", hasError: false },
        zipCode: { value: "", hasError: false },
        city: { value: "", hasError: false },
        country: { value: "", hasError: false },
        progress: { value: 0 },
      },
      selectDeliveryTitle: "Cliquez pour ajouter une prestation",
      selectedDelivery: "Cliquez pour ajouter une prestation",
      dataDeliveries: [
        {
          type: DeliveryType.HOME,
          title: "Expertise avant achat d’une maison",
          surface: "",
        },
        {
          type: DeliveryType.APARTMENT,
          title: "Expertise avant achat d’un appartement",
          surface: "",
        },
        { type: DeliveryType.SWIMMING_POOL, title: "Piscine", surface: "" },
        {
          type: DeliveryType.VEFA_HOME_BULKHEAD,
          title: "VEFA - Maison - Visite cloisons",
          surface: "",
        },
        {
          type: DeliveryType.VEFA_HOME_PRE_DELIVERY,
          title: "VEFA - Maison - Pré-livraison / Réserves (sans TMA)",
          surface: "",
        },
        {
          type: DeliveryType.VEFA_HOME_RECEPTION_DELIVERY,
          title: "VEFA - Maison - Réception / Livraison",
          surface: "",
        },
        {
          type: DeliveryType.VEFA_APARTMENT_BULKHEAD,
          title: "VEFA - Appartement - Visite cloisons",
          surface: "",
        },
        {
          type: DeliveryType.VEFA_APARTMENT_PRE_DELIVERY,
          title: "VEFA - Appartement - Pré-livraison / Réserves (sans TMA)",
          surface: "",
        },
        {
          type: DeliveryType.VEFA_APARTMENT_RECEPTION_DELIVERY,
          title: "VEFA - Appartement - Réception / Livraison",
          surface: "",
        },
        {
          type: DeliveryType.CCMI_FOUNDATION,
          title: "Visite fondation - CCMI",
          surface: "",
        },
        {
          type: DeliveryType.CCMI_BIG_WORK,
          title: "Visite gros Oeuvre - CCMI",
          surface: "",
        },
        {
          type: DeliveryType.CCMI_BULKHEAD,
          title: "Visite cloisons - CCMI",
          surface: "",
        },
        {
          type: DeliveryType.CCMI_COPE,
          title: "Visite chape - CCMI",
          surface: "",
        },
        {
          type: DeliveryType.CCMI_RECEPTION_DELIVERY,
          title: "Réception & Livraison - CCMI",
          surface: "",
        }
      ],
      selectCommunicationTitle: "Comment nous avez-vous connu ?",
      selectedCommunicationType: "Comment nous avez-vous connu ?",
      dataCommunicationTypes: [
        { type: CommunicationType.RADIO, title: "Radio" },
        { type: CommunicationType.TV, title: "TV" },
        { type: CommunicationType.PRESS, title: "Article de presse" },
        { type: CommunicationType.INTERNET, title: "Internet" },
        { type: CommunicationType.FRIEND, title: "Amis" },
        { type: CommunicationType.FACEBOOK, title: "Facebook" },
        { type: CommunicationType.LINKEDIN, title: "LinkedIn" },
        { type: CommunicationType.TWITTER, title: "Twitter" },
        { type: CommunicationType.AD_BOARD, title: "Panneau publicitaire" },
        { type: CommunicationType.OTHER, title: "Autre" },
      ],
      selectedDeliveries: [],
      isChecked: false,
      isLoading: false,
      isConnected: false,
      userCanPay: false,
    };
  },
  methods: {
    addDelivery: function (delivery) {
      if (delivery.title != this.selectDeliveryTitle) {
        this.selectedDeliveries.push(delivery);
        this.selectedDelivery = this.selectDeliveryTitle;
      }
      this.setProgress();
    },

    deleteDeliveryAt: function (index) {
      this.selectedDeliveries.splice(index, 1);
      this.setProgress();
    },

    getMinimumSurfaceForDelivery(delivery) {
      return delivery.type == DeliveryType.GARDEN ||
        delivery.type == DeliveryType.WATERING ||
        delivery.type == DeliveryType.GARDEN
        ? 300
        : 1;
    },

    getUnitLabelForDelivery(delivery) {
      switch (delivery.type) {
        case DeliveryType.DELIVERY_ASSISTANCE_COMMON_PART:
          return "Nombre de lots";
        case DeliveryType.SWIMMING_POOL:
          return "Nombre de piscine";
        default:
          return "Surface";
      }
    },

    isEmail: function () {
      var regex = RegExp("[a-z0-9._%+-]+@[a-z0-9.-]+.[a-z]{2,}$");
      this.form.email.value = this.form.email.value.trim();
      this.form.email.hasError = !regex.test(this.form.email.value);
      if (this.form.email.hasError) {
        this.form.email.errorMessage =
          "Votre adresse email n'est pas au bon format.";
      } else {
        this.form.email.errorMessage = "";
      }
      this.setProgress();
    },

    isPhoneNumber: function () {
      var regex = RegExp("0.*[0-9]{9}$");
      this.form.phoneNumber.value = this.form.phoneNumber.value.trim();
      this.form.phoneNumber.hasError = !regex.test(this.form.phoneNumber.value);
      if (this.form.phoneNumber.hasError) {
        this.form.phoneNumber.errorMessage =
          "Doit commencer par 0 et comporter 10 chiffres.";
      } else {
        this.form.phoneNumber.errorMessage = "";
      }
      this.setProgress();
    },

    isZipCode: function () {
      var regex = RegExp("[0-9]{5}$");
      this.form.zipCode.value = this.form.zipCode.value.trim();
      this.form.zipCode.hasError = !regex.test(this.form.zipCode.value);
      if (this.form.zipCode.hasError) {
        this.form.zipCode.errorMessage = "Doit comporter 5 chiffres.";
      } else {
        this.form.zipCode.errorMessage = "";
      }
      this.setProgress();
    },

    checkFirstName: function () {
      var regex = RegExp("[a-z0-9._%+-]{2,}");
      this.form.firstName.value = this.form.firstName.value.trim();
      this.form.firstName.hasError = !regex.test(this.form.firstName.value);
      if (this.form.firstName.hasError) {
        this.form.firstName.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.firstName.errorMessage = "";
      }
      this.setProgress();
    },

    checkLastName: function () {
      var regex = RegExp("[a-z0-9._%+-]{2,}");
      this.form.lastName.value = this.form.lastName.value.trim();
      this.form.lastName.hasError = !regex.test(this.form.lastName.value);
      if (this.form.lastName.hasError) {
        this.form.lastName.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.lastName.errorMessage = "";
      }
      this.setProgress();
    },

    checkAddress: function () {
      var regex = RegExp("[a-z0-9._%+-]{2,}");
      this.form.address.value = this.form.address.value.trim();
      this.form.address.hasError = !regex.test(this.form.address.value);
      if (this.form.address.hasError) {
        this.form.address.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.address.errorMessage = "";
      }
      this.setProgress();
    },

    checkCity: function () {
      var regex = RegExp("[a-z0-9._%+-]{2,}");
      this.form.city.value = this.form.city.value.trim();
      this.form.city.hasError = !regex.test(this.form.city.value);
      if (this.form.city.hasError) {
        this.form.city.errorMessage = "Doit contenir au moins deux caractères";
      } else {
        this.form.city.errorMessage = "";
      }
      this.setProgress();
    },

    checkCountry: function () {
      var regex = RegExp("[a-z0-9._%+-]{2,}");
      this.form.country.value = this.form.country.value.trim();
      this.form.country.hasError = !regex.test(this.form.country.value);
      if (this.form.country.hasError) {
        this.form.country.errorMessage =
          "Doit contenir au moins deux caractères";
      } else {
        this.form.country.errorMessage = "";
      }
      this.setProgress();
    },

    setProgress: function () {
      var progress = 10;
      progress +=
        this.form.firstName.value == "" || this.form.firstName.hasError
          ? 0
          : 10;
      progress +=
        this.form.lastName.value == "" || this.form.lastName.hasError ? 0 : 10;
      progress +=
        this.form.gender.value == "" || this.form.gender.hasError ? 0 : 10;
      progress +=
        this.form.email.value == "" || this.form.email.hasError ? 0 : 10;
      progress +=
        this.form.address.value == "" || this.form.address.hasError ? 0 : 10;
      progress +=
        this.form.zipCode.value == "" || this.form.zipCode.hasError ? 0 : 10;
      progress +=
        this.form.city.value == "" || this.form.city.hasError ? 0 : 10;
      progress +=
        this.form.country.value == "" || this.form.country.hasError ? 0 : 10;
      progress += this.selectedDeliveries.length == 0 ? 0 : 10;
      this.form.progress.value = progress;

      UIkit.util.ready(function () {
        var bar = document.getElementById("progressbar");
        bar.value = progress;
      });
    },

    deliveryAlreadySelected: function (delivery) {
      return !this.selectedDeliveries.includes(delivery);
    },

    createQuotation: function () {
      this.isLoading = true;
      const data = {
        firstName: this.form.firstName.value,
        lastName: this.form.lastName.value,
        gender: this.form.gender.value,
        phoneNumber: this.form.phoneNumber.value,
        email: this.form.email.value,
        address: {
          address: this.form.address.value,
          zipCode: this.form.zipCode.value,
          city: this.form.city.value,
          country: this.form.country.value,
        },
        deliveries: this.selectedDeliveries,
        communicationType: this.selectedCommunicationType,
        quotationID: makeQuotationID(8),
      };

      if (this.isConnected) {
        data.ownerUID = this.currentUser.uid;
      } else {
        data.ownerUID = "";
      }

      firebase
        .firestore()
        .collection("Quotations")
        .add(data)
        .then(() => {
          setTimeout(function () {
            this.isLoading = false;
            router.push({
              path: `quotation-creation-success/${data.quotationID}`,
            });
          }, 2500);
        })
        .catch(function (error) {
          console.log("Error getting documents: ", error);
        });
    },
  },
};

function makeQuotationID(length) {
  var result = "";
  var characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  var charactersLength = characters.length;
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
}
</script>

<style scoped>
.white-background {
  background-color: white;
}
</style>